module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerabbrs01",
      "epub:type": "frontmatter",
      "id": "abbrs"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerabbrs01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "epub:type": "pagebreak",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chibentley0006#toc"
    }
  }, [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('div', {
    staticClass: "glossary"
  }, [_c('p', {
    staticClass: "glof"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "pvii"
    }
  }), _c('abbr', [_vm._v("HJA")]), _vm._v(" – Hogan Jazz Archive, Tulane University, New Orleans")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('abbr', [_vm._v("HNOC")]), _vm._v(" – Williams Research Center, Historic New Orleans Collection, New Orleans")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('abbr', [_vm._v("LARC")]), _vm._v(" – Louisiana Research Collection, Tulane University, New Orleans")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('abbr', [_vm._v("LSM")]), _vm._v(" – Louisiana Historical Center, Louisiana State Museum, New Orleans")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('abbr', [_vm._v("NONA")]), _vm._v(" – New Orleans Notarial Archives")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('abbr', [_vm._v("NOPL")]), _vm._v(" – New Orleans Public Library")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('abbr', [_vm._v("SCLSU")]), _vm._v(" – Special Collections, Louisiana State University, Baton Rouge, Louisiana")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2256e258","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-bentley-0007.vue
// module id = 72
// module chunks = 0